import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { addBranch, deleteBranch, getBranch, updateBranch } from "../../reducers/commonReducer";
import { home, users } from "../../const";
import BranchAction from "./BranchAction";

const Branch = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(getBranch());
  }, []);

  const { getBranchList } = useSelector((state) => state.commonReducer);

  const handleDeleteConfirm = async () => {
    setDeleting(true);
    const resp = await dispatch(deleteBranch(deleteTarget.id));
    setDeleting(false);
    setDeleteTarget(null);
    if (resp?.payload?.status) {
      dispatch(getBranch());
    }
  };
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <Row className="mt-1 mb-2">
          <Col md={4}>
            <BranchAction
              title="Branch"
              popupTitle={"Add Branch"}
              api={addBranch}
            />
          </Col>
        </Row>
        <table className="table w-100">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Set As Primary</th>
              <th className="over-col-size">Description</th>
              <th className="over-col-size">Branch Leader</th>
              <th className="over-col-size">Team Leader's</th>
              <th className="over-col-size">Users</th>
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody>
            {!!getBranchList &&
              getBranchList?.map((data, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>
                        <b>{data?.setAsPrimary ? <span className="text-success">Active</span> : 
                        <span className="text-danger">InActive</span>}</b>
                      </td>
                      <td>{data?.description}</td>
                      <td>
                        <Button variant={"primary"} onClick={() => navigate(`${users}?branch=${data?.id}&role=${`branch_leader`}&branchName=${data?.name}`)}><i className="bi bi-eye-fill"></i></Button>
                      </td>
                      <td>
                        <Button variant={"primary"} onClick={() => navigate(`${users}?branch=${data?.id}&role=${`team_leader`}&branchName=${data?.name}`)}><i className="bi bi-eye-fill"></i></Button>
                      </td>
                      <td>
                        <Button variant={"primary"} onClick={() => navigate(`${users}?branch=${data?.id}&role=${`customer`}&branchName=${data?.name}`)}><i className="bi bi-eye-fill"></i></Button>
                      </td>
                      <td>
                        <b>{data?.status ? <span className="text-success">Active</span> : 
                        <span className="text-danger">InActive</span>}</b>
                      </td>
                      <td>
                        <div className="d-flex gap-2 align-items-center">
                          <BranchAction
                            api={updateBranch}
                            popupTitle={"Update Group"}
                            name={data?.name}
                            setAsPrimary={data?.setAsPrimary}
                            description={data?.description}
                            status={data?.status}
                            id={data?.id}
                          />
                          {data?.name?.toLowerCase() !== 'testbranch' && (
                            <Button
                              variant="danger"
                              onClick={() => setDeleteTarget(data)}
                            >
                              <i className="bi bi-trash"></i>
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>

      <Modal show={!!deleteTarget} onHide={() => !deleting && setDeleteTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Branch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete <b>{deleteTarget?.name}</b>?
          </p>
          <p className="text-danger mb-0">
            This will permanently delete all users, messages, and uploaded files under this branch.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteTarget(null)} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm} disabled={deleting}>
            {deleting ? "Deleting..." : "Delete Branch"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Branch;
